import { Dispatch, PropsWithChildren, SetStateAction, useEffect } from 'react';
import { initializeAutodeskViewing } from 'src/components/viewers/common/utils/autodesk';
import { useForgeAccessToken } from 'src/hooks/forge-auth';

export type Props = PropsWithChildren<{
  projectId: string;
  setViewingInitialized: Dispatch<SetStateAction<boolean>>;
}>;

export function AutodeskViewing({
  projectId,
  setViewingInitialized,
  children,
}: Props) {
  const { getAccessToken } = useForgeAccessToken(projectId);

  useEffect(() => {
    initializeAutodeskViewing({ getAccessToken }).then(() => {
      console.info('Initialized viewing');
      setViewingInitialized(true);
    });
  }, [getAccessToken, setViewingInitialized]);

  return <>{children}</>;
}
